import React, { PureComponent } from 'react';

import classNames from 'classnames';
import { ButtonIcon } from 'components/button';
import { I18n } from 'components/translate';
import PropTypes from 'prop-types';

import './Accordion.scss';

export default class AccordionToggle extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    opened: PropTypes.bool,
    openToggle: PropTypes.node,
    closeToggle: PropTypes.node,
    onToggle: PropTypes.func,
    onlyClose: PropTypes.bool
  };

  static defaultProps = {
    openToggle: (
      <ButtonIcon
        className="accordion__button"
        transparent
        type="button"
        icon="open-arrow"
      >
        <I18n label="general.open" />
      </ButtonIcon>
    ),
    closeToggle: (
      <ButtonIcon
        className="accordion__button"
        transparent
        type="button"
        icon="close-arrow"
      >
        <I18n label="general.close" />
      </ButtonIcon>
    ),
    onlyClose: false
  };

  render() {
    const { children, className, opened, onToggle } = this.props;

    const classComponent = classNames(
      'accordion__toggle',
      { 'accordion__toggle--active': opened },
      className
    );

    return (
      <div key="header" className={classComponent} onClick={onToggle}>
        {children ? children : this.textToggle}
      </div>
    );
  }

  get textToggle() {
    const { openToggle, closeToggle, opened, onlyClose } = this.props;

    if (!onlyClose || opened) {
      return opened ? closeToggle : openToggle;
    }
  }
}
